<template>
  <div class="block-form">
    <v-btn text @click="dialog = true">
      <v-icon class="mr-1">{{ buttonIcon }}</v-icon> {{ buttonLabel }}
    </v-btn>

    <v-dialog v-model="dialog" max-width="450">
      <v-card>
        <v-card-title class="headline">{{ buttonLabel }} user</v-card-title>
        <v-card-text>
          Are you sure you want to {{ buttonLabel.toLowerCase() }} this account?

          <v-row v-if="!isBlocked">
            <v-col>
              <label class="text-field-label">Reason</label>
              <v-textarea
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                v-model="form.reason_for_blocking"
                :error-messages="form.$getError('reason_for_blocking')"
                :loading="form.$busy"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="dialog = false" :loading="form.$busy"
            >Cancel</v-btn
          >

          <v-btn
            :color="buttonState"
            text
            @click="onSubmit"
            :loading="form.$busy"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" right :color="snackbar.color">
      {{ snackbar.message }}
      <v-btn text @click="snackbar.show = false">OK</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Block/Unblock form
 * ==================================================================================
 **/

import { mapActions } from 'vuex'
import { mdiLock, mdiLockOpen } from '@mdi/js'
import User from '@/models/User'
import Form from '@/utils/form'

export default {
  props: {
    user: {
      type: [User, Object]
    }
  },

  data() {
    return {
      icons: {
        block: mdiLock,
        unblock: mdiLockOpen
      },
      form: new Form({
        reason_for_blocking: null
      }),

      dialog: false,

      snackbar: {
        show: false,
        message: null,
        color: ''
      }
    }
  },

  computed: {
    submit() {
      return this.isBlocked ? this.unblockUser : this.blockUser
    },

    buttonLabel() {
      return `${this.isBlocked ? 'Unblock' : 'Block'}`
    },

    buttonState() {
      return this.isBlocked ? 'primary' : 'red'
    },

    buttonIcon() {
      return this.isBlocked ? this.icons.unblock : this.icons.block
    },

    isBlocked() {
      return this.user ? !this.user.active : false
    }
  },

  methods: {
    ...mapActions({
      blockUser: 'user/blockUser',
      unblockUser: 'user/unblockUser'
    }),

    async onSubmit() {
      if (this.form.$busy) return
      this.form.$setLoading(true)

      let message = `User successfully ${this.buttonLabel.toLowerCase()}ed!`
      await this.submit({
        id: this.user.id,
        reason_for_blocking: this.form.reason_for_blocking
      })
        .then(data => {
          this.form.$setLoading(false)
          this.dialog = false

          this.showSnackbar(message, 'success')
        })
        .catch(error => {
          this.form.$setLoading(false)
          this.form.$handleError(error)
          this.showSnackbar(this.form.$errorMessage, 'danger')
        })
    },

    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    }
  }
}
</script>
